import React from 'react';
import muzickiVremeplov from './images/Muzicki vremeplov.jpg'
import Mocart from './images/Bio jednom jedan Mocart plakat.jpg'
import morskaAvantura from './images/Velika morska avantura.jpg'
import potragaZaBlagom from './images/Potraga za blagom.jpg'
import sneznaKraljica from './images/Snezna kraljica.jpg'
import carevoOdelo from './images/Carevo novo odelo.jpg'
import carolijaNaKraju from './images/Carolija na kraju predstave.jpg'
import cistologija from './images/Cistologija.jpg'
import askaVuk from './images/Aska i vuk.jpg'
import velikiBal from './images/velikiBal.jpg'
import princezaZabac from './images/Princeza i zabac.jpg'
import tajnaKofera from './images/Tajna Carobnog kofera iza kulisa.jpg'
import uspavanaRuzica from './images/Uspavana Ruzica.jpg'
import indijanci from './images/Plakat Indijanci.jpg'
import RepertoarSection from './RepertoarSection';

function Repertoar() {
  return (
    <div className='repertoarContainer'>
<RepertoarSection />
      <img src={muzickiVremeplov} className='muzickiVremeplov'></img>
      <img src={Mocart} className='muzickiVremeplov'></img>
      <img src={morskaAvantura} className='muzickiVremeplov'></img>
      <img src={potragaZaBlagom} className='muzickiVremeplov'></img>
      <div>
      <img src={sneznaKraljica} className='muzickiVremeplov'></img>
      <img src={carevoOdelo} className='muzickiVremeplov'></img>
      <img src={carolijaNaKraju} className='muzickiVremeplov'></img>
      <img src={cistologija} className='muzickiVremeplov'></img>
      </div>
      <div>
      <img src={askaVuk} className='muzickiVremeplov'></img>
      <img src={velikiBal} className='muzickiVremeplov'></img>
      <img src={princezaZabac} className='muzickiVremeplov'></img>
      <img src={tajnaKofera} className='muzickiVremeplov'></img>
      </div>
      <div>
      <img src={uspavanaRuzica} className='muzickiVremeplov'></img>
      <img src={indijanci} className='muzickiVremeplov'></img>
      </div>
    </div>
  );
}

export default Repertoar;